import { gql } from "@apollo/client";

export const ADD_SPEAKER = gql`
  mutation AddPublicSpeaker($input: NewSpeakerInput, $topic: String) {
    createSpeaker(input: $input, topic: $topic) {
      id
    }
  }
`;
